// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__lMqHG","overallTable":"style__overallTable__UE63e"};